import type { ThinkingLevel } from "open-pi-agent";

export const DEFAULT_THINKING_LEVEL: ThinkingLevel = "medium";
